import { render, staticRenderFns } from "./book-prefer.vue?vue&type=template&id=45b4311a&scoped=true"
import script from "./book-prefer.vue?vue&type=script&lang=js"
export * from "./book-prefer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45b4311a",
  null
  
)

export default component.exports